import { recalculateTargetGrossMargin } from '../strategies/target-gross-margin';

export const recalculateRAFTargetGrossMargin = recalculateTargetGrossMargin;
